import { truncate } from "lodash"

export class EpsonEncoder {
    protected queue: Array<string|object> = [
        '\x1B' + '\x74' + '\x10',
    ]
    constructor(readonly width: number = 48) {}

    newLine(amount: number = 1) {
        for (let index = 0; index < amount; index++) {
            this.queue.push('\x0A')
        }
        return this
    }

    stroke() {
        let stroke = ''
        for (let index = 0; index < this.width; index++) {
            stroke += '-'
        }
        this.queue.push(stroke)
        this.newLine()
        return this
    }

    table(data: (string | number)[]) {
        const cellWidth = this.width / data.length;

        data.forEach(el => {
            let lineTxt = ""
            lineTxt += el.toString()
            lineTxt = truncate(lineTxt, { length: 30 })
            const spaces = cellWidth - lineTxt.length
            for (let j = 0; j < spaces; j++) {
                lineTxt += " ";
            }
            this.align('right')
            this.queue.push(lineTxt)
        })
        this.align('left')
        this.newLine()
        return this;
    }

    chr(n: number) { return String.fromCharCode(n); };

    barCode(data: string, type: 'CODE128' | 'CODE39' = 'CODE128') {
        if (!data || data.length === 0) {
            console.warn('Code-barres vide, ignoré')
            return this
        }
        // Code 39
        if (type == 'CODE39') {
            const cleanData = data.toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 20)
            this.queue.push('\x1D\x68\x64')
            this.queue.push('\x1D\x77\x02')
            this.queue.push('\x1D\x48\x02')
            this.queue.push('\x1D\x6B\x04' + cleanData + '\x00')
        }
        // Code 128
        if (type == 'CODE128') {
            const cleanData = data.replace(/[^0-9]/g, '')
            this.queue.push('\x1D\x68\x64')  // Hauteur
            this.queue.push('\x1D\x77\x02')  // Largeur
            this.queue.push('\x1D\x48\x02')  // Texte dessous
            this.queue.push('\x1D\x6B\x49' + cleanData + '\x00')
        }
        return this
    }

    qrCode(qr: string) {
        const qrLength = qr.length + 3;
        const size1 =  String.fromCharCode(qrLength % 256)
        const size0 = String.fromCharCode(Math.floor(qrLength / 256))
        const dots = '\x09'
        this.queue.push('\x1D' + '\x28' + '\x6B' + '\x04' + '\x00' + '\x31' + '\x41' + '\x32' + '\x00')
        this.queue.push('\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x43' + dots)
        this.queue.push('\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x45' + '\x30')
        this.queue.push('\x1D' + '\x28' + '\x6B' + size1 + size0 + '\x31' + '\x50' + '\x30' + qr)
        this.queue.push('\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x51' +'\x30')
        this.queue.push('\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x52' +'\x30')
        return this
    }

    doubleSize(text: string) {
        this.queue.push('\x1D' + '\x21' + '\x10')
        this.queue.push(text)
        this.queue.push('\x1D' + '\x21' + '\x00')
        return this
    }

    base64Image(data: string, options: any = { language: "ESCPOS", dotDensity: 'double' }) {
        this.queue.push({
            type: 'raw',
            format: 'image',
            data,
            options
        })
        return this
    }

    image(path: string, options: any = {language: "ESCPOS", dotDensity: 'double', scaleContent: false}) {
        this.queue.push({
            type: 'raw',
            format: 'image',
            data: path,
            options
        })
        return this
    }

    underline(text: string) {
        this.queue.push('\x1B' + '\x2D' + '\x02')
        this.queue.push(text)
        this.queue.push('\x1B' + '\x2D' + '\x00')
        this.newLine()
        return this
    }

    small(text: string) {
        this.queue.push('\x1B' + '\x4D' + '\x31')
        this.queue.push(text)
        this.queue.push('\x1B' + '\x4D' + '\x30')
        this.newLine()
        return this
    }

    bold(text: string) {
        this.queue.push('\x1B' + '\x45' + '\x0D')
        this.queue.push(text)
        this.queue.push('\x1B' + '\x45' + '\x0A')
        this.newLine()
        return this
    }

    init() {
        this.queue.push('\x1B' + '\x40')
        return this
    }

    pulse() {
        this.queue.push('\x10' + '\x14' + '\x01' + '\x00' + '\x05')
        return this
    }

    h1(text: string) {
        this.queue.push('\x1B' + '\x21' + '\x30')
        this.queue.push(text)
        this.queue.push('\x1B' + '\x21' + '\x0A' + '\x1B' + '\x45' + '\x0A')
        this.newLine()
        return this
    }

    cut(type: 'full' | 'partial' = 'partial') {
        if (type == 'partial') {
            this.queue.push('\x1D' + '\x56'  + '\x01')
        }
        if (type == 'full') {
            this.queue.push('\x1D' + '\x56'  + '\x30')
        }
        return this
    }

    align(align: 'left' | 'center' | 'right') {
        if (align == 'center') {
            this.queue.push('\x1B' + '\x61' + '\x31')
        }
        if (align == 'right') {
            this.queue.push('\x1B' + '\x61' + '\x32')
        }
        if (align == 'left') {
            this.queue.push('\x1B' + '\x61' + '\x30')
        }
        return this
    }

    line(text: string) {
        this.queue.push(text)
        this.newLine()
        return this
    }

    endCode() {
        return this.queue
    }
}